import { useEffect, useRef } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const stats = [
  { value: '360°', numeric: 360, suffix: '°', label: 'Multi-source assessments', sub: 'Peers, managers & self-review' },
  { value: '3', numeric: 3, suffix: '', label: 'Modules in one platform', sub: 'Kinerja · Wawasan · Rekrut' },
  { value: '<1 hr', numeric: null, suffix: '', label: 'Full workforce mapping', sub: 'From setup to 9-box placement' },
  { value: '∞', numeric: null, suffix: '', label: 'Employees supported', sub: 'From 15 to enterprise scale' },
]

export function LandingStats() {
  const sectionRef = useRef<HTMLElement>(null)
  const valueRefs = useRef<(HTMLSpanElement | null)[]>([])
  const itemRefs = useRef<(HTMLDivElement | null)[]>([])

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Set initial states
      gsap.set(itemRefs.current, { opacity: 0, y: 20 })

      ScrollTrigger.create({
        trigger: sectionRef.current,
        start: 'top 82%',
        once: true,
        onEnter: () => {
          // Stagger items in
          gsap.to(itemRefs.current, {
            opacity: 1, y: 0, duration: 0.55, ease: 'power2.out',
            stagger: 0.12,
          })

          // Count up numeric values
          stats.forEach((stat, i) => {
            const el = valueRefs.current[i]
            if (!el) return

            if (stat.numeric !== null) {
              gsap.fromTo(
                { val: 0 },
                { val: stat.numeric },
                {
                  val: stat.numeric,
                  duration: 1.6,
                  ease: 'power2.out',
                  delay: i * 0.12,
                  onUpdate: function () {
                    el.textContent = Math.round(this.targets()[0].val) + stat.suffix
                  },
                },
              )
            } else {
              // Non-numeric: scale-pop in
              gsap.fromTo(
                el,
                { scale: 0.6, opacity: 0 },
                { scale: 1, opacity: 1, duration: 0.55, ease: 'back.out(1.7)', delay: i * 0.12 + 0.1 },
              )
            }
          })
        },
      })
    }, sectionRef)

    return () => ctx.revert()
  }, [])

  return (
    <section ref={sectionRef} className="border-y border-[#e8f5f5] bg-[#f9fefe] py-10 px-6 md:px-10 lg:px-[120px]">
      <div className="max-w-screen-xl mx-auto grid grid-cols-2 gap-8 lg:grid-cols-4">
        {stats.map((s, i) => (
          <div
            key={s.label}
            ref={(el) => { itemRefs.current[i] = el }}
            className="flex flex-col items-center text-center gap-1"
          >
            <span
              ref={(el) => { valueRefs.current[i] = el }}
              className="text-[32px] font-semibold text-[#27777a] leading-tight tracking-tight lg:text-[40px]"
            >
              {s.value}
            </span>
            <span className="text-sm font-semibold text-[#000f0f]">{s.label}</span>
            <span className="text-xs text-[#878989]">{s.sub}</span>
          </div>
        ))}
      </div>
    </section>
  )
}
